import { Collection } from '../../models/Collection';
import { rModelsBase } from './.catalog';

export interface SonucListesi {
  Anahtar: string;
  Deger: number;
}

export default class rIstatistikSonuc_4 extends rModelsBase {
  constructor(
    options1?: {
      SonucListesi: SonucListesi[];
      AnahtarTuru: string;
      DegerTuru: string;
      Yillar: number[];
      Toplam: number;
    },
    options2?: rIstatistikSonuc_4
  ) {
    super();
    this.SonucListesi = new Collection(
      options1?.SonucListesi || options2?.SonucListesi?.list() || []
    );
    this.AnahtarTuru = options1?.AnahtarTuru || options2?.AnahtarTuru;
    this.DegerTuru = options1?.DegerTuru || options2?.DegerTuru;
    this.Yillar = options1?.Yillar || options2?.Yillar;
    this.Toplam = options1?.Toplam || options2?.Toplam;
  }

  public SonucListesi: Collection<SonucListesi>;
  public Yillar: number[] | undefined;
  public AnahtarTuru: string | undefined;
  public DegerTuru: string | undefined;
  public Toplam: number | undefined;
}
